// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3575":"c507f1bd","7606":"c507f1bd","9262":"c507f1bd"}[chunkId] + ".chunk.css";
};